
export const ResponseType = {
  showResponse:'showResponse',
  showDashBoardResponse:'showDashBoardResponse',
  showUserResponse:'showUserResponse',
  showWalletResponse:'showWalletResponse',
  showWalletServiceResponse:'showWalletServiceResponse',
  showUserProfileResponse:"showUserProfileResponse",
  showTransaction:"showTransaction",
  fetchTransaction:"fetchTransaction",
  showExpiringFirstResponse:"showExpiringFirstResponse",
  showCashBackResponse:"showCashBackResponse",
  showCreditNoteResponse:"showCreditNoteResponse",
  showBonusCashResponse:"showBonusCashResponse",
  setAllUserData:"setAllUserData",
  setAllWalletTxn:"setAllWalletTxn",
  setAllPgTxn:" setAllPgTxn",
  showTxnResponse:"showTxnResponse",
  showTxnResponsePager:"showTxnResponsePager",
  showTxnResponseLength:"showTxnResponseLength",
  showAdminProfileResponse:"showAdminProfileResponse",
  setAllCampaignsResponse:"setAllCampaignsResponse",
  showCreateOrderResponse:"showCreateOrderResponse",
  showCreateOrderResponseArr:"showCreateOrderResponseArr",
  setMoneyTransferResponse:"setMoneyTransferResponse",

  //recharge
  showCreateOrderResponse1:'showCreateOrderResponse1',
  
  RESET: "RESET",
      
      
    };